import * as React from "react";
import { Query, QueryCondition, AuditTrailEntity } from "../../misc/api/apiTypes";
import { getQueryFilters } from "../../misc/components/queryTable/ReducerUtilities";
import MultiSelectModal from "../../misc/components/queryTable/MultiSelectModal";
import uniqBy from "lodash-es/uniqBy";
import { GetFilterValues } from "../../misc/components/queryTable/FilterValuesSelector";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

export interface UserFilterProps {
    analysisSetOldId: number;
    filterableEntityTypes: string[];
    auditQuery: Query<AuditTrailEntity>;
    isUserFilterVisible: boolean;
    onChange: (eventQuery: Query<AuditTrailEntity>) => void;
    onClose: () => void;
}

export interface UserFilterState {
    userQuery: Query<AuditTrailEntity>;
}

export const UserFilter = (props: UserFilterProps) => {
    const client = useWebPortalApiClient();
    const [usernameQueryMember] = React.useState("Event.User.Username");
    const [userOptions, setUserOptions] = React.useState([]);
    const { study } = useCurrentStudyConfigurationContext();

    const fetchUsers = async () => {
        const usersResult = await client.client.getCoughAnalysisSets("analyst", `session/visit/subject/site/studyId eq ${study.id}`);

        setUserOptions(usersResult.value);
    }

    React.useEffect(() => {
        fetchUsers();
    }, [props.analysisSetOldId]);

    const onUserChange = async event => {
        // Need to send the undefined value here as the Query should filter on a null User entity with a undefined Username
        const eventMapped = event.map(x => x === "System" ? undefined : x);

        const filters = getQueryFilters(
            props.auditQuery,
            usernameQueryMember,
            QueryCondition.Equal,
            eventMapped
        );

        const eventsQuery: Query<AuditTrailEntity> = {
            ...props.auditQuery,
            Filters: filters
        };

        props.onChange(eventsQuery);
    };

    const userUniqueQuery = userOptions
        ? uniqBy(userOptions, x => x.analyst)
        : [];

    const userQuerySelector = userUniqueQuery.map(x => x.analyst ? x : { analyst: "System" });

    const values = GetFilterValues(
        usernameQueryMember,
        QueryCondition.Equal,
        props.auditQuery
    )

    const valuesSelector = values ? values.map(x => !x ? "System" : x) : [];

    return (
        <ErrorBoundary>
            <MultiSelectModal
                header="User Filter"
                show={props.isUserFilterVisible}
                options={userQuerySelector}
                valueKey={"analyst"}
                labelKey={"analyst"}
                values={valuesSelector}
                onChange={e => onUserChange(e.map(v => v.analyst))}
                onClose={() => props.onClose()}
            />
        </ErrorBoundary>
    );
}
